(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bentivana-article"]) return;
  try {
    
document.querySelectorAll('.bv-article-page').forEach(root=>{
const body=root.querySelector('.bv-article-article-body'),toc=root.querySelector('.bv-article-toc');
body.querySelectorAll('p').forEach(p=>{if(/^Nombre de mots\s*:\s*\d+\s*$/i.test(p.textContent.trim()))p.remove()});
body.querySelectorAll('h2').forEach((h,i)=>{if(!h.id)h.id='guide-section-'+i;const a=document.createElement('a'),n=document.createElement('span');a.href='#'+h.id;n.textContent=String(i+1).padStart(2,'0');a.append(n,document.createTextNode(h.textContent));toc.append(a)});
if(!toc.children.length){toc.previousElementSibling.hidden=true;toc.hidden=true}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bentivana-contact"] && !Shopify.designMode) return;
  try {
    
if (document.documentElement.lang.toLowerCase().startsWith('en')) {

document.querySelectorAll('.bv-contact').forEach(root => {
const select=root.querySelector('#sujet'),hint=root.querySelector('#hint');select.addEventListener('change',()=>{const tips={"Advice before buying":"Tell us which product interests you and, if relevant, the dimensions available in your hallway.","Tracking my order":"Include the number from your confirmation email and the email address used to order.","A delivery":"Include your order number and describe the delivery issue.","A return or refund":"Include your order number and the product concerned.","A damaged or incomplete product":"Describe the items concerned. You can email your photos to info@bentivana.com."};hint.textContent=tips[select.value]||"An exact reference helps us identify the product or order concerned."});});

} else if (document.documentElement.lang.toLowerCase().startsWith('de')) {


document.querySelectorAll('.bv-contact').forEach(root => {
const select=root.querySelector('#sujet'),hint=root.querySelector('#hint');select.addEventListener('change',()=>{const tips={"Beratung vor dem Kauf":"Teilen Sie uns mit, für welches Produkt Sie sich interessieren und welche Maße ggf. in Ihrem Flur zur Verfügung stehen.","Sendungsverfolgung meiner Bestellung":"Geben Sie die Nummer aus Ihrer Bestätigungs-E-Mail und die für die Bestellung verwendete E-Mail-Adresse an.","Eine Lieferung":"Geben Sie Ihre Bestellnummer an und beschreiben Sie das Lieferproblem.","Eine Rückgabe oder Rückerstattung":"Geben Sie Ihre Bestellnummer und das betroffene Produkt an.","Ein beschädigtes oder unvollständiges Produkt":"Beschreiben Sie die betreffenden Artikel. Sie können Ihre Fotos per E-Mail an info@bentivana.com senden."};hint.textContent=tips[select.value]||"Eine genaue Referenz hilft uns, das betreffende Produkt oder die Bestellung zu identifizieren."});});


} else {

document.querySelectorAll('.bv-contact').forEach(root => {
const select=root.querySelector('#sujet'),hint=root.querySelector('#hint');select.addEventListener('change',()=>{const tips={'Un conseil avant achat':'Précisez le produit qui vous intéresse et, si besoin, les dimensions disponibles dans votre entrée.','Le suivi de ma commande':'Indiquez le numéro figurant dans votre e-mail de confirmation et l’adresse e-mail utilisée pour commander.','Une livraison':'Précisez votre numéro de commande et la difficulté rencontrée lors de la livraison.','Un retour ou un remboursement':'Indiquez votre numéro de commande et le produit concerné par votre demande.','Un produit reçu abîmé ou incomplet':'Décrivez les éléments concernés. Vous pouvez envoyer vos photos par e-mail à info@bentivana.com.'};hint.textContent=tips[select.value]||'Une référence précise nous aide à identifier le produit ou la commande concernés.'});});

}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bentivana-journal"] && !Shopify.designMode) return;
  try {
    
if (document.documentElement.lang.toLowerCase().startsWith('en')) {

document.querySelectorAll('.bv-journal').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';
const cards=[...root.querySelectorAll('.bv-journal__card')],buttons=[...root.querySelectorAll('[data-filter]')],search=root.querySelector('#search');let category="All articles",limit=6;const norm=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();function render(){const matches=cards.filter(c=>(category==="All articles"||c.dataset.category===category)&&norm(c.textContent).includes(norm(search.value)));cards.forEach(c=>c.hidden=true);matches.slice(0,limit).forEach(c=>c.hidden=false);root.querySelector('#count').textContent=matches.length+' article'+(matches.length!==1?'s':'')+' · '+Math.min(limit,matches.length)+' shown';root.querySelector('.bv-journal__empty').hidden=matches.length>0;root.querySelector('.bv-journal__more').hidden=matches.length<=limit}buttons.forEach(b=>b.addEventListener('click',()=>{category=b.dataset.filter;limit=6;buttons.forEach(x=>x.setAttribute('aria-pressed',String(x===b)));render()}));search.addEventListener('input',()=>{limit=6;render()});root.querySelector('#more').addEventListener('click',()=>{limit+=6;render()});render();});

} else if (document.documentElement.lang.toLowerCase().startsWith('de')) {


document.querySelectorAll('.bv-journal').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';
const cards=[...root.querySelectorAll('.bv-journal__card')],buttons=[...root.querySelectorAll('[data-filter]')],search=root.querySelector('#search');let category="Alle Artikel",limit=6;const norm=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();function render(){const matches=cards.filter(c=>(category==="Alle Artikel"||c.dataset.category===category)&&norm(c.textContent).includes(norm(search.value)));cards.forEach(c=>c.hidden=true);matches.slice(0,limit).forEach(c=>c.hidden=false);root.querySelector('#count').textContent=matches.length+' Artikel · '+Math.min(limit,matches.length)+' angezeigt';root.querySelector('.bv-journal__empty').hidden=matches.length>0;root.querySelector('.bv-journal__more').hidden=matches.length<=limit}buttons.forEach(b=>b.addEventListener('click',()=>{category=b.dataset.filter;limit=6;buttons.forEach(x=>x.setAttribute('aria-pressed',String(x===b)));render()}));search.addEventListener('input',()=>{limit=6;render()});root.querySelector('#more').addEventListener('click',()=>{limit+=6;render()});render();});


} else {

document.querySelectorAll('.bv-journal').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';
const cards=[...root.querySelectorAll('.bv-journal__card')],buttons=[...root.querySelectorAll('[data-filter]')],search=root.querySelector('#search');let category='Tous les articles',limit=6;const norm=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();function render(){const matches=cards.filter(c=>(category==='Tous les articles'||c.dataset.category===category)&&norm(c.textContent).includes(norm(search.value)));cards.forEach(c=>c.hidden=true);matches.slice(0,limit).forEach(c=>c.hidden=false);root.querySelector('#count').textContent=matches.length+' article'+(matches.length>1?'s':'')+' · '+Math.min(limit,matches.length)+' affiché'+(Math.min(limit,matches.length)>1?'s':'');root.querySelector('.bv-journal__empty').hidden=matches.length>0;root.querySelector('.bv-journal__more').hidden=matches.length<=limit}buttons.forEach(b=>b.addEventListener('click',()=>{category=b.dataset.filter;limit=6;buttons.forEach(x=>x.setAttribute('aria-pressed',String(x===b)));render()}));search.addEventListener('input',()=>{limit=6;render()});root.querySelector('#more').addEventListener('click',()=>{limit+=6;render()});render();});

}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bentivana-reassurance"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();

    function init(root) {
      if (instances.has(root)) return;
      const track = root.querySelector('[data-bv-reassurance-track]');
      const items = [...root.querySelectorAll('[data-bv-reassurance-item]')];
      const dots = [...root.querySelectorAll('[data-bv-reassurance-dot]')];
      if (!track || items.length < 2) return;

      const mobile = window.matchMedia('(max-width: 899px)');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const delay = Math.max(3000, Number(root.dataset.delay) || 5500);
      const controller = new AbortController();
      const { signal } = controller;
      let visible = false;
      let userStopped = false;
      let index = 0;
      let interval;

      function stop() {
        if (interval) window.clearInterval(interval);
        interval = undefined;
      }

      function show(next, behavior = 'smooth') {
        index = (next + items.length) % items.length;
        track.scrollTo({ left: items[index].offsetLeft - items[0].offsetLeft, behavior });
        dots.forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === index);
          if (dotIndex === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      function update() {
        const shouldPlay = root.dataset.autoplay === 'true' && mobile.matches && !reduceMotion.matches && visible && !userStopped && !document.hidden;
        if (!shouldPlay) { stop(); return; }
        if (!interval) interval = window.setInterval(() => show(index + 1), delay);
      }

      function hold() {
        userStopped = true;
        stop();
      }

      dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => {
        show(dotIndex);
        hold();
      }, { signal }));

      track.addEventListener('pointerdown', hold, { passive: true, signal });
      track.addEventListener('scroll', () => {
        const nearest = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (nearest !== index && nearest >= 0 && nearest < items.length) {
          index = nearest;
          dots.forEach((dot, dotIndex) => {
            dot.classList.toggle('is-active', dotIndex === index);
            if (dotIndex === index) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }
      }, { passive: true, signal });

      const observer = 'IntersectionObserver' in window
        ? new IntersectionObserver(entries => { visible = entries[0].isIntersecting; update(); }, { threshold: .25 })
        : null;
      if (observer) observer.observe(root);
      else visible = true;

      mobile.addEventListener('change', update, { signal });
      reduceMotion.addEventListener('change', update, { signal });
      document.addEventListener('visibilitychange', update, { signal });
      update();
      instances.set(root, () => {
        stop();
        if (observer) observer.disconnect();
        controller.abort();
      });
    }

    function scan(scope = document) {
      scope.querySelectorAll('[data-bv-reassurance]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
    else scan();
    document.addEventListener('shopify:section:load', event => scan(event.target));
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll('[data-bv-reassurance]').forEach(root => {
        const cleanup = instances.get(root);
        if (cleanup) cleanup();
        instances.delete(root);
      });
    });
    document.addEventListener('shopify:block:select', event => {
      const item = event.target.closest('[data-bv-reassurance-item]');
      if (!item) return;
      const root = item.closest('[data-bv-reassurance]');
      if (!root) return;
      const track = root.querySelector('[data-bv-reassurance-track]');
      track.scrollTo({ left: item.offsetLeft - track.firstElementChild.offsetLeft, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
